var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"shared-display-container"},_vm._l((_vm.value),function(user){return _c('v-chip',{key:user,staticClass:"ml-2 pa-1",attrs:{"small":""}},[_vm._v(" "+_vm._s(user)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }